import { isObject } from 'lodash'

import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import { UserDetail } from '@/types/user'

export async function updateUserDetails(
  dataToUpdate: Partial<UserDetail>
): Promise<UserDetail> {
  if (!isObject(dataToUpdate)) return {} as UserDetail
  const body = JSON.stringify(dataToUpdate)
  return (await makePatchRequest(`${ApiBase}/profiles/me`, {
    body,
  })) as Promise<UserDetail>
}
